import PluginFilterList from './PluginFilterList';
import PluginList from './PluginsList';
import { useEffect, useState } from 'react';
import { actions } from '../../../context';
import { useDispatch } from 'react-redux';
import { Container } from 'reactstrap';
import AddPluginModal from '../../Modals/MissionControl/PluginManager/AddPluginModal';
import PluginDetailsModal from './PluginDetailsModal';
import MissionControlDetails from './MissionControlDetails';

const MissionControlManager = () => {
    const dispatch = useDispatch();

    const [isPluginDetailModalOpen, setIsPluginDetailModalOpen] =
        useState(false);
    const [isAddPluginModalOpen, setIsAddPluginModalOpen] = useState(false);

    useEffect(() => {
        return () => {
            dispatch(actions.missionControl.setPimsFilter(''));
            dispatch(actions.missionControl.setFilter(''));
            dispatch(actions.missionControl.setIncludeInactivePlugins(false));
        };
        // eslint-disable-next-line
    }, [dispatch]);

    return (
        <>
            <PluginDetailsModal
                isOpen={isPluginDetailModalOpen}
                closeModalBehavior={() => setIsPluginDetailModalOpen(false)}
            />
            <AddPluginModal
                isOpen={isAddPluginModalOpen}
                closeModalBehavior={() => setIsAddPluginModalOpen(false)}
            />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Mission Control Manager</h1>
                            </div>
                        </div>
                    </div>
                </section>

                <Container id="dashboard" className="my-4 ov-dashboard">
                    <MissionControlDetails />
                    <PluginFilterList
                        openAddModalBehavior={() =>
                            setIsAddPluginModalOpen(true)
                        }
                    />
                    <PluginList
                        openPluginDetails={() =>
                            setIsPluginDetailModalOpen(true)
                        }
                    />
                </Container>
            </div>
        </>
    );
};

export default MissionControlManager;
